import { z } from "zod";
import { File } from "../../../../../schemas";

export const SecondFormSchema = z.object({
    screenshot: File,
})